<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <h1>Oops!</h1>
    <span>No se pudo enviar la notificación</span>
    <v-btn
      color="primary"
      elevation="2"
      type="button"
      class="action"
      :loading="loading"
      :disabled="loading"
      @click.stop="EliminarTokenPush"
    >
      GENERAR NUEVO TOKEN
    </v-btn>
  </div>
</template>
<script>
import { db, ms, getToken } from "../../firebase";

export default {
  data() {
    return {
      loading: false,
    };
  },
  props: {
    toastId: {
      type: [String, Number],
      required: true,
    },
  },
  methods: {
    EliminarTokenPush() {
      this.loading = true;
      const indexedDB =
        window.indexedDB ||
        window.mozIndexedDB ||
        window.webkitIndexedDB ||
        window.msIndexedDB;
      indexedDB.deleteDatabase("firebase-messaging-database");
      indexedDB.deleteDatabase("firebase-heartbeat-database");
      indexedDB.deleteDatabase("firebase-installations-database");

      // this.$toast.update(this.toastId, {
      //   content: "Actualizado...",
      //   options: {
      //     type: "success",
      //     position: "top-right",
      //     timeout: 2413,
      //     closeOnClick: false,
      //     pauseOnFocusLoss: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     draggablePercent: 0.6,
      //     showCloseButtonOnHover: false,
      //     hideProgressBar: true,
      //     closeButton: "button",
      //     icon: "fas fa-rocket",
      //     rtl: false,
      //   },
      // });
      setTimeout(() => {
        this.loading = false;
        window.location.reload();
      }, 3000);
    },
    generarTokenPush() {
      getToken(ms, {
        vapidKey:
          "BLno6H879Rx6st3UIqx42SnZ8C5yarj6YOTQ_Ed6CSTZgF0O6vlCqiMt2WPhRhEk8yp3wCoee7-cmK2LTWxOPxs",
      })
        .then((currentToken) => {
          if (currentToken) {
            // console.log(currentToken);
            localStorage.setItem("tokenPush", currentToken);
            let objUser = JSON.parse(localStorage.getItem("logueado"));
            db.collection("usuarios")
              .doc(objUser.id)
              .update({
                tokenPush: currentToken,
              })
              .then(() => {
                this.$toast.update(this.toastId, {
                  content: "Token Actualizado!",
                  options: {
                    type: "success",
                    position: "top-right",
                    timeout: 2413,
                    closeOnClick: false,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: "fas fa-rocket",
                    rtl: false,
                  },
                });
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
    },
  },
};
</script>
<style scoped>
.container {
  height: 25vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.action {
  height: 40px;
  padding: 5px 10px;
  border-radius: 5px;
  color: #000000;
  cursor: pointer;
  border: thin solid currentColor;
  background-color: #ffc008;
}

button,
input,
select,
textarea {
  background-color: transparent;
  border-style: none;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffc008;
  color: #000000;
}

span,
h1 {
  color: #000000;
}

.Vue-Toastification__close-button {
  color: #000 !important;
}
</style>
